import DynamicVideo from "components/DynamicVideo"
import Link from "next/link"

export default function VideoReview({ video, category, client_name, slug }) {
  return (
    <div className="bg-white h-full max-h-fit flex flex-col items-center border-0.5 border-grey-cool">
      <DynamicVideo
        component={video[0].component}
        {...video[0]}
        title={video[0]?.title ?? client_name ? client_name : "Video Review"}
      />
      <h2 className="text-center p-8 flex flex-col justify-center h-full max-h-fit">
        {client_name ? (
          <span className="block text-base font-primary font-medium text-primary mb-3 capitalize">
            {category?.name}
          </span>
        ) : null}
        <Link href={slug}>
          <span className="text-primary hover:underline text-m3 lg:text-l1">
            {client_name ? client_name : "Video Review"}
          </span>
        </Link>
      </h2>
    </div>
  )
}
